import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import useLoadEntities from 'hooks/useLoadEntities'

import Link from 'suitTheme/Link'
import FormField from 'components/forms/FormField'
import SearchCampaigns from 'suitTheme/SearchCampaigns'
import SidebarModal from 'modals/sidebar/SidebarModal'

const defaultRequestOptions = {
  include_campaign_agent_ids: true,
  include_campaign_image: true,
  include_campaign_images: true,
  include_campaign_orders: true,
  include_image_sizes: true,
}

const Campaign = (props) => {
  const {
    imageSelectPayload: {
      callbacks: { selectEntity },
      selectedEntity,
      selectedEntityType,
      selectedEntityId,
    },
  } = props

  const {
    address, default_image, id, suburb_name,
  } = selectedEntity

  // Load Selected Campaign
  useLoadEntities(
    'agency',
    'campaigns',
    defaultRequestOptions,
    [selectedEntityType, selectedEntityId],
    {
      actionName: 'loadCampaign',
      dispatchAction: (action, requestOptions) => action(selectedEntityId, requestOptions),
      shouldPerformFn: (entityReducer) => {
        const { loadedIds, loading, errors } = entityReducer
        return (
          selectedEntityType === 'Campaign'
          && selectedEntityId
          && !loadedIds.includes(selectedEntityId)
          && !loading
          && !errors.length
        )
      },
    },
  )

  return (
    <>
      <FormField direction="column" label="Search Campaigns">
        <SearchCampaigns
          callbacks={{ selectItem: selected => selectEntity({ type: 'Campaign', id: selected.id }) }}
        />
      </FormField>

      {!!selectedEntity.id && (
        <SidebarModal.Campaign
          boxProps={{ borderBottom: '1px dashed', borderColor: 'lineColor' }}
          disableHover
          imageUrl={default_image}
          key={id}
          subtitle={suburb_name}
          title={address}
        >
          <Link greyLink onClick={() => selectEntity({ type: 'Campaign', id: 0 })} textProps={{ fontSize: 'small' }}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </Link>
        </SidebarModal.Campaign>
      )}
    </>
  )
}

Campaign.propTypes = {
  imageSelectPayload: PropTypes.shape({
    callbacks: PropTypes.shape({
      selectEntity: PropTypes.func.isRequired,
    }).isRequired,
    selectedEntity: PropTypes.object.isRequired,
    selectedEntityId: PropTypes.number.isRequired,
    selectedEntityType: PropTypes.string.isRequired,
  }).isRequired,
}

export default Campaign
